export default __webpack_public_path__ + "static/media/mercedes.9bae7bcb.gif";